const generateDuplicationName = (existingNames, currentName) => {
  let counter = 0;
  let potentialName = currentName + ' (copy)';
  let duplicatedPotentialName = potentialName;
  let isNameUnique = false;
  const checkUniqueness = name => {
    return existingNames.every(n => n !== name);
  };
  while (!isNameUnique) {
    isNameUnique = checkUniqueness(duplicatedPotentialName);

    if (!isNameUnique) {
      counter++;
      duplicatedPotentialName = potentialName + ' (' + counter + ')';
    }
  }
  return duplicatedPotentialName;
};

export default generateDuplicationName;
